// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Router from "next/router";
import * as MediaQuery$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as PnMHelper$PorterinFeature from "../../domain/helper/PnMHelper.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as ModalContext$PorterinFeature from "../../../../contexts/modal-context/ModalContext.mjs";
import * as AuthContextV1$PorterinFeature from "../../../login/view-model/contexts/auth-context/AuthContextV1.mjs";
import * as PnMRepoManager$PorterinFeature from "../../domain/repo/PnMRepoManager.mjs";
import * as PnMBaseFormInterface$PorterinFeature from "./PnMBaseFormInterface.mjs";
import * as CourierBookingFlowHelper$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/CourierBookingFlowHelper.mjs";
import * as PnMFareEstimateFormState$PorterinFeature from "./PnMFareEstimateFormState.mjs";
import * as PnMFareEstimateFormModuleScss from "../styles/PnMFareEstimateForm.module.scss";
import * as PnMFareEstimateInputModuleScss from "../styles/PnMFareEstimateInput.module.scss";
import * as PnMFareEstimateFormFieldsCmp$PorterinFeature from "../PnMFareEstimateFormFieldsCmp.mjs";

var default_form_styles = PnMFareEstimateFormModuleScss;

var default_input_styles = PnMFareEstimateInputModuleScss;

function PnMFareEstimateFormCmp(Props) {
  var hasAllRoundedCornersOpt = Props.hasAllRoundedCorners;
  var stylesOpt = Props.styles;
  var input_field_stylesOpt = Props.input_field_styles;
  var show_house_sizeOpt = Props.show_house_size;
  var hasAllRoundedCorners = hasAllRoundedCornersOpt !== undefined ? hasAllRoundedCornersOpt : false;
  var styles = stylesOpt !== undefined ? Caml_option.valFromOption(stylesOpt) : default_form_styles;
  var input_field_styles = input_field_stylesOpt !== undefined ? Caml_option.valFromOption(input_field_stylesOpt) : default_input_styles;
  var show_house_size = show_house_sizeOpt !== undefined ? Caml_option.valFromOption(show_house_sizeOpt) : undefined;
  var router = Router.useRouter();
  var isDesktop = MediaQuery$PorterinUtils.useMediaQuery("(min-width: 560px)");
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  PnMRepoManager$PorterinFeature.getRepo(undefined);
  var match = ModalContext$PorterinFeature.useModalContext(undefined);
  var toggleModal = match.toggleModal;
  var match$1 = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var user = match$1.user;
  var is_authenticated = match$1.is_authenticated;
  var match$2 = React.useState(function () {
        return PnMBaseFormInterface$PorterinFeature.initial_form_state(user, Belt_Option.getWithDefault(show_house_size, false));
      });
  var setPreviousInput = match$2[1];
  var match$3 = React.useState(function () {
        
      });
  var setResponse = match$3[1];
  var response = match$3[0];
  var form = PnMBaseFormInterface$PorterinFeature.PnMBaseForm.useForm(match$2[0], (function (output, callbacks) {
          var partial_arg = output.mobile;
          PnMFareEstimateFormState$PorterinFeature.onFormSubmit(output, callbacks, isDesktop, citySelectedContext, setResponse, (function (param) {
                  if (!(!isDesktop && CourierBookingFlowHelper$PorterinUtils.isCourierBookingFlowEnabled(partial_arg))) {
                    return Curry._1(toggleModal, {
                                TAG: /* PnMCallbackConfirmationModal */15,
                                _0: true
                              });
                  }
                  var srExternalId = PnMHelper$PorterinFeature.getSrExternalId(response);
                  return Curry._1(toggleModal, {
                              TAG: /* PnMBookingFlow */14,
                              _0: true,
                              _1: srExternalId,
                              _2: partial_arg
                            });
                }), show_house_size, router.query, undefined);
        }));
  React.useEffect((function () {
          var match = form.input.mobile;
          if (user !== undefined && is_authenticated && match === "") {
            Curry._2(form.updateMobile, (function (input, value) {
                    return {
                            pickup: input.pickup,
                            drop: input.drop,
                            date: input.date,
                            name: input.name,
                            mobile: value,
                            house: input.house,
                            show_house_field: input.show_house_field
                          };
                  }), Belt_Option.getWithDefault(user.mobile, ""));
          }
          
        }), [
        form,
        user,
        is_authenticated
      ]);
  React.useEffect((function () {
          var match = form.status;
          var exit = 0;
          if (typeof match === "number") {
            if (match !== /* Editing */0) {
              exit = 1;
            }
            
          } else if (match.TAG !== /* Submitting */0) {
            exit = 1;
          }
          if (exit === 1) {
            Curry._1(setPreviousInput, (function (param) {
                    return form.input;
                  }));
            Curry._1(form.reset, undefined);
          }
          
        }), [form.status]);
  return React.createElement("div", {
              className: hasAllRoundedCorners ? "" + styles["rounded-corners"] + " " + styles["pnm-fare-estimate-container"] + "" : styles["pnm-fare-estimate-container"]
            }, React.createElement(PnMFareEstimateFormFieldsCmp$PorterinFeature.make, {
                  form: form,
                  styles: styles,
                  input_field_styles: input_field_styles,
                  response: response,
                  show_house_size: Belt_Option.getWithDefault(show_house_size, false)
                }));
}

var make = PnMFareEstimateFormCmp;

export {
  default_form_styles ,
  default_input_styles ,
  make ,
}
/* default_form_styles Not a pure module */
